import { FormatConstants } from 'services/keyConstants';

export const updateLinkedData = (columns, rows, targetArray) => {
    // Extract linked keys and corresponding values from the rows
    const linkedDataMap = columns?.reduce((acc, col) => {
        if (col?.linkedKey) {
            // Find value from the row based on the column value using optional chaining
            const rowValue = rows?.[0]?.[col?.value] ?? '';
            acc[col.linkedKey] = rowValue;
        }
        return acc;
    }, {});

    // Update the target array with the linked data
    const updatedArray = targetArray?.map(item => {
        if (item?.linkedKey && linkedDataMap?.[item?.linkedKey]) {
            return {
                ...item,
                inputValue: linkedDataMap[item?.linkedKey],
                isReadOnly: true, // Make it read-only as required
            };
        }
        return item;
    });

    return updatedArray;
};

export const getStatusTypes = (type) => {
    switch (type) {
      case FormatConstants.CUSTOMER_PROPERTY.LIST_OF_CUSTOMER_PROPERTY:
        return {
          filteredData: {
            page: 1,
            totalPage: 1,
            status: "",
          },
          defaultOptionData: {
            statusOptions: [
              { label: "Initiated", value: "Initiated" },
              { label: "Accepted", value: "Accepted" },
              { label: "Not Accepted", value: "Not Accepted" },
            ]
          }
        };
        break;

        case FormatConstants.CUSTOMER_PROPERTY.CUSTOMER_PROPERTY_REPORTING_FORM:
        return {
          filteredData: {
            page: 1,
            totalPage: 1,
            status: "",
          },
          defaultOptionData: {
            statusOptions: [
              { label: "Retained", value: "Retained" },
              { label: "Returned", value: "Returned" },
              { label: "Dispose", value: "Dispose" },
            ]
          }
        };
        break;
  
      // Default case if no matching type is found
      default:
        return {
          filteredData: {
          },
          defaultOptionData: {
            statusOptions: []
          }
        };
    }
  };